import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { installmentsStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
}) =>
  priceType === paywallPriceTypes.installments &&
  !hasUpfrontPayment &&
  hasTrialPeriod;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  currency,
  trialPeriodDays,
  watch,
}) => {
  const totalAmount = mapCurrencyAmountStrToInt(watch("amount"));
  const installmentsCount = parseInt(watch("installments_count"));
  const installmentAmount = Math.round(totalAmount / installmentsCount);
  const intervalType = watch("billing_frequency");

  // Locale variables
  const member_free_trial_phrase = t(
    [localeRoot, "phrases", "member_free_trial"],
    {
      count: trialPeriodDays,
    },
  );
  const count = installmentsCount;
  const installment_amount = formatPaywallCurrencyAmount(
    currency,
    installmentAmount,
  );
  const total_amount_phrase = t([localeRoot, "phrases", "total_amount"], {
    amount: formatPaywallCurrencyAmount(currency, totalAmount),
  });

  return [
    ["trial_then_installments", intervalType],
    {
      member_free_trial_phrase,
      count,
      installment_amount,
      total_amount_phrase,
    },
  ];
};

export const trialThenInstallments: NoticeScenario = {
  matcher,
  stateValidator: installmentsStateValidator,
  messagePropsResolver,
};
